import { render } from "./ChatReplyTo.vue?vue&type=template&id=49d3b310"
import script from "./ChatReplyTo.vue?vue&type=script&lang=js"
export * from "./ChatReplyTo.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__